module.exports = __webpack_public_path__ + "static/media/wpp.974e4727.png";